import {Heading} from "./Heading";
import { ReactNode } from "react";

interface ListProps {
  heading?: string;
  children: ReactNode | ReactNode[];
  className?:string;
}

export const List = ({heading, children, className}: ListProps) => {
  return (
    <>
      {
        heading &&
          <Heading>{heading}</Heading>
      }
      <ul className={"ml-8 space-y-2 md:space-y-4 list-disc mb-4 " + className}>
        {children}
      </ul>
    </>
  );
};
